import { Company } from "./companies";

export enum IsOpenType {
  NOT_OPENED = 0,
  OPENED = 1,
  CLOSED = 2,
  DEREGISTERING_CLOSED = 3,
}

export interface Event {
  id: number;
  company: Company;
  company_contact_id: number;
  food: string;
  comments: string;
  is_open: IsOpenType;
  seats: number;
  short_feedback: string;
  feedback_file_id: number;
  overbooking: number;
  vip_seats: number;
  is_visible: number;
  in_english: boolean;
  name: string;
  start: string;
  location: number;
  close: string;
  event_type: number;
  open: string;
  no_shows_sent: boolean;
  use_waiting_list: boolean;
  admin: boolean;
  waiting_list_size: number;
  attachment: string;
  sectors: number[];
  registrations?: number;
  registration_status: EventRegistrationStatus | null;
  coverImage: string;
  duration: string;
  description: string;
}

export interface EventRegistration {
  id: number;
  event: number;
  student: number;
  created_at: string;
  did_eat: boolean;
  time_attended: string;
}

export interface EventDerigistration {
  id: number;
  event: number;
  student: number;
  created_at: string;
}

export interface EventWaitlistRegistration {
  id: number;
  event: number;
  student: number;
  created_at: string;
}

export type EventRegistrationStatus =
  | "REGISTERED"
  | "WAITLIST_AVAILABLE"
  | "NOT_RELEVANT"
  | "AVAILABLE"
  | "FULL"
  | "REGISTERED_FOR_WAITLIST"
  | "NOT_OPEN"
  | "BANNED";

export interface StudyProgramQuota {
  id: number;
  shared_quota: number;
  study_programme: number;
  study_programme_name: string;
  study_programme_shortname: string;
  year_levels_accepted: number[];
  students_allowed: number;
}

export interface SharedQuota {
  id: number;
  event: number;
  max_students_allowed: number;
  attendee_registragtion_allow_all: boolean;
  is_company_vip: boolean;
}

export interface Location {
  id: number;
  name: string;
  capacity: number;
}

export const RESPONSIBILITY_TYPES = {
  1: "HA",
  2: "Mini-HA",
  3: "MP",
  4: "Mini-MP",
};

export interface EventResponsibility {
  id: number;
  event: number;
  bl_member: number;
  responsibility_type: keyof typeof RESPONSIBILITY_TYPES;
}

export interface EventType {
  id: number;
  title: string;
}

export interface LogEntry {
  id: number;
  student: number;
  event: number;
  event_name: string;
  event_start: string;
  time_attended: string;
}

export interface NoShow {
  id: number;
  time: string;
  notification_sent: boolean;
  got_banned: boolean;
  is_used: boolean;
  student: number;
  no_show_type: 0 | 1;
  event: number;
  student_first_name: string;
  student_last_name: string;
  event_name: string;
}
